import * as api from "../../../api";
import React, { useState } from "react";
import { Link } from "react-router-dom";

import { Lock, Person } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { ALERT, AUTH } from "../../../constants/actionTypes";

import { createQuote } from "../../../utils/createQuote";

import "./Signin.css";

const Signin = ({ payment, closeModal, order, auth, path }) => {
  const uploadQuote = useSelector((state) => state.upload);
  const history = useHistory();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const disable =
    formData.email.trim() === "" ||
    (path === "reset" ? false : formData.password.trim() === "") ||
    loading;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (path === "reset") {
        await api.resetPasswordEmail({ email: formData.email });
        setFormData({ ...formData, email: "" });
        dispatch({
          type: ALERT,
          payload: {
            severity: "success",
            message: "Reset link has been sent to your email",
            duration: 7000,
            display: true,
          },
        });
      } else {
        const { data } = await api.signIn(formData);
        dispatch({ type: AUTH, data });
        if (payment) closeModal();
        if (auth) handleToDashboard(data);
        if (order) createQuote(uploadQuote, setLoading, dispatch, history);
      }
    } catch (error) {
      if (error.response)
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: error.response.data.message,
            duration: 5000,
            display: true,
          },
        });
      else
        dispatch({
          type: ALERT,
          payload: {
            severity: "error",
            message: "An unexpected error occurred",
            duration: 5000,
            display: true,
          },
        });
    } finally {
      setLoading(false);
    }
  };

  const handleToDashboard = (user) => {
    if (user.role === "basic") history.push("/projects/index");
    if (user.role === "translator") history.push("/translator/profile");
    if (user.role === "admin") history.push("/admin/index");
  };

  const modalStyle = {
    position: "absolute",
    top: "15%",
    left: 0,
    right: 0,
  };

  return (
    <form
      style={auth ? {} : modalStyle}
      className="signin__form d-flex flex-column align-center justify-center p-40 z-5 m-auto"
    >
      <h3 className="font-subhead">
        {path === "reset" ? "RESET PASSWORD" : "SIGN IN"}
      </h3>
      <p className="font-sm mb-40">
        Enter your {path === "reset" ? "Email" : "login credentials"} below
      </p>
      <label className="d-flex align-center border-bottom-1 py-10 w-100 mb-40">
        <Person className="icon-light-grey mb-5" />
        <input
          className="w-100 outline-0 border-0 px-20"
          type="email"
          value={formData.email}
          placeholder="Email Address"
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
      </label>
      {path !== "reset" && (
        <label className="d-flex align-center border-bottom-1 py-10 w-100">
          <Lock className="icon-light-grey mb-5" />
          <input
            className="w-100 outline-0 border-0 px-20"
            type="password"
            autoComplete="true"
            value={formData.password}
            placeholder="Password"
            onChange={(e) =>
              setFormData({ ...formData, password: e.target.value })
            }
          />
        </label>
      )}
      {path !== "reset" && (
        <Link to="/auth/reset" className="auth__link w-100 text-right mt-5">
          Forgot password?
        </Link>
      )}
      <button
        style={{ opacity: disable ? "0.6" : "" }}
        className="signin__btn d-flex align-center justify-center w-100 font-normal font-bolder border-0 outline-0 p-10 mt-40 rounded"
        onClick={handleSubmit}
        disabled={disable}
      >
        {path === "reset" ? "Reset Password" : "Sign In"}
        {loading && <div className="spin-white ml-10"></div>}
      </button>
      {path !== "reset" && (
        <Link
          to="/auth/signup"
          className="auth__link w-100 text-center mt-5 pt-20"
        >
          Don't have an account? Sign up
        </Link>
      )}
      {path === "reset" && (
        <Link
          to="/auth/signin"
          className="auth__link w-100 text-center mt-5 pt-20"
        >
          Back to Sign in
        </Link>
      )}
    </form>
  );
};

export default Signin;
